import React from 'react';
import PropTypes from "prop-types";
import {Row, Col} from "reactstrap";
import "./Header.scss";
import SearchField from "./SearchField";
import {connect} from "react-redux";
import QsignPracovnikField from "./field/QsignPracovnikField";
import QsignPodepisujiciField from "./field/QsignPodepisujiciField";

/**
 * Header.
 */
class Header extends React.Component {
    static propTypes = {
        button: PropTypes.any.isRequired,
        title: PropTypes.string.isRequired,
        searchUserField: PropTypes.bool,
        searchSignerField: PropTypes.bool,
        searchField: PropTypes.bool,
    };

    render() {
        const {button, title, searchUserField, searchSignerField, searchField, searchPlaceholder} = this.props;

        return (
            <div className="header d-none d-md-block">
                <Row noGutters className="w-100 header-container">
                    <Col className="header-button">{button}</Col>
                    <Col className="header-box">
                        <Row noGutters className="w-100">
                            <Col md={6}>
                                <h2 className="title">{title}</h2>
                            </Col>
                            <Col md={6}>
                                <Row noGutters className="w-100">
                                    {searchUserField && (
                                        <Col className={'mr-2'}>
                                            <div className={'searchField'} style={{height: 42}}>
                                                <QsignPracovnikField key={"selectedPracovnikToFilter"} empty={true}/>
                                            </div>
                                        </Col>
                                    )}
                                    {searchSignerField && (
                                        <Col className={'mr-2'}>
                                            <QsignPodepisujiciField key={"selectedPodepoisujiciToFilter"} empty={true}/>
                                        </Col>
                                    )}
                                    {searchField && (
                                        <Col>
                                            <SearchField
                                                onChange={(value) => {
                                                    this.props.history.push("/vyhledavani?q=" + value);
                                                }}
                                                placeholder={searchPlaceholder || "Vyhledat v dokumentech"}
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        <hr className="header-border hidden-xs-down"/>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(Header);

